import { createBrowserHistory } from 'history';

const historyInstance = createBrowserHistory();

// Compatibility shim: history@5 renamed goBack→back, goForward→forward
(historyInstance as any).goBack = () => historyInstance.back();
(historyInstance as any).goForward = () => historyInstance.forward();

export class History {
  getObject() {
    return historyInstance;
  }

  replace(url: string) {
    window.location.replace(url);
  }

  push(url: string) {
    window.location.href = url;
  }
}

export const history = new History();
export default historyInstance;
